// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-result-container-quiz {
  height: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  color: #979ea4;
  padding: 30px 20px 0px 15px;
  text-align: center;
  font-size: 16px;
  margin-bottom: 15px;
  background-color: #fff;
}

.MuiDataGrid-virtualScrollerContent.css-1kwdphh-MuiDataGrid-virtualScrollerContent {
  flex-basis: var(--DataGrid-overlayHeight, calc(var(--height) * 5)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/NoResultQuiz/NoResultQuiz.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6EAA6E;AAC/E","sourcesContent":[".no-result-container-quiz {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  color: #979ea4;\n  padding: 30px 20px 0px 15px;\n  text-align: center;\n  font-size: 16px;\n  margin-bottom: 15px;\n  background-color: #fff;\n}\n\n.MuiDataGrid-virtualScrollerContent.css-1kwdphh-MuiDataGrid-virtualScrollerContent {\n  flex-basis: var(--DataGrid-overlayHeight, calc(var(--height) * 5)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
